// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
import { MoveCardControlsTemplate } from 'app/scripts/views/templates/MoveCardControlsTemplate';
const t = teacupWithHelpers('popover_move_card');
import { MoveCardPopoverTestIds } from '@trello/test-ids';

export const PopoverMoveCardTemplate = () => {
  const suggestions = t.mustacheVar('suggestions');
  if (suggestions.length > 0) {
    t.div('.pop-over-section.js-suggestions', function () {
      t.h4(function () {
        t.icon('sparkle');
        return t.format('suggested');
      });

      for (const list of Array.from(suggestions)) {
        t.a(
          '.button-link.js-suggested-move',
          {
            class: t.classify({
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              'flip-icon': list.direction === 'left',
            }),
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            'data-id': list.id,
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            'data-position': list.position,
            href: '#',
          },
          function () {
            t.icon('move');
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            return t.text(list.name);
          },
        );
      }
    });
  }

  return t.div('.pop-over-section', function () {
    t.h4(() => t.format('select-destination'));

    t.mustachePartial(MoveCardControlsTemplate);

    return t.input('.nch-button.nch-button--primary.wide.js-submit', {
      type: 'submit',
      value: t.l('move'),
      'data-testid': MoveCardPopoverTestIds.MoveButton,
    });
  });
};
